import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ErrorBaseCurrencyAmountChartFallback = () => {
  const { t } = useTranslation();
  return <Alert severity="error">{t("chartHistory.baseCurrencyAmountChart.error")}</Alert>;
};

export default ErrorBaseCurrencyAmountChartFallback;
